import React, { useState, useEffect, useContext, useRef } from "react";
import api from "../../../../../services/api";
import { Empresa, SiteEmpresa } from "../../../../../entities/Common";
import classnames from "classnames";
import List from "./List";
import Form from "./Form";
import SimpleHeader from "../../../../../components/Headers/SimpleHeader";
import Equipes from "../../../../marketing/Campanhas/Anuncios/Equipes";
// @ts-ignore
import NotificationAlert from "react-notification-alert";

import {
  Button,
  Card,
  CardBody,
  CardHeader,
  CardImg,
  CardText,
  CardTitle,
  Col,
  Nav,
  NavItem,
  NavLink,
  Row,
  TabContent,
  TabPane,
} from "reactstrap";
import EmpresaContext from "../../../../../contexts/Empresa";
import ReactBSAlert from "react-bootstrap-sweetalert";

import { Sites as ISites } from "../../../../security/Users/me/components/Paginas";
import useModal from "./modals/useModal";
import { SelecionarModeloModal } from "./modals/SelecionarModeloModal";
import { EditarModeloModal } from "./modals/EditarModeloModal";
import { SelecionarPaginasVendasModal } from "./modals/SelecionarPaginasVendasModal";

export interface ModeloSite {
  id: number;
  link: string;
  tipo_modelo: "afiliacao" | "indicacao" | "pagina_vendas";
  params_map: string;
}

interface ParametroSite {
  id: number;
  chave: string;
  valor: string;
  descricao: string;
  usuario_modelo_site_id: string;
}

interface ModeloSiteParams {
  id: string;
  modelo_site_id: number;
  parametroSite: ParametroSite[];
  site: ModeloSite;
  short_url?: string;
}
export interface UsuarioModeloSite extends ModeloSiteParams {
  user_empresa_id: number;
}

type Anuncio = {
  id: number;
  nome: string;
  campanha_id: number;
};
export interface EmpresaModeloSite extends ModeloSiteParams {
  empresa_id: number;
  anuncio_id?: number; // << vem da coluna nova na tabela
  anuncio?: Anuncio;
}

function asArray<T>(x: T | T[] | null | undefined): T[] {
  return Array.isArray(x) ? x : x ? [x] : [];
}

const Sites: React.FC = () => {
  const { empresaSelecionada } = useContext(EmpresaContext);
  const [sites, setSites] = useState(new Array<SiteEmpresa>());
  const [showForm, setShowForm] = useState(false);
  const [activeTab, setTabActive] = useState("indicacao");
  const notificationAlert = useRef<any>();
  const [paginasVendas, setPaginasVendas] = useState<EmpresaModeloSite[]>([]);
  const [alert, setAlert] = useState<React.ReactNode | null>(null);
  const [showEquipesModal, setShowEquipesModal] = useState(false);
  const [campanhaPaginaVendasId, setCampanhaPaginaVendasId] = useState<
    number | null
  >(null);

  const [selectedAnuncio, setSelectedAnuncio] = useState<Anuncio | null>(null);
  const [loadingAnuncio, setLoadingAnuncio] = useState(false);

  const [modelosSites, setModelosSites] = useState<ModeloSite[]>([]);
  const [paginaIndicacao, setPaginaIndicacao] = useState<EmpresaModeloSite>();
  const [isModalVendedorVisible, setIsModalVendedorVisible] = useModal();
  const [isEditModalVendedorVisible, setIsEditModalVendedorVisible] =
    useModal();

  const [paginaVendasSelecionadas, setPaginaVendasSelecionadas] = useState<
    ModeloSite[]
  >([]);
  const [isModalPaginasVendasOpen, setIsModalPaginasVendasOpen] =
    useState(false);

  const [equipesPorAnuncio, setEquipesPorAnuncio] = useState<
    Record<number, number>
  >({});

  useEffect(() => {
    (async () => {
      if (!paginasVendas.length || !empresaSelecionada?.id) return;

      let campanhaId = campanhaPaginaVendasId;
      if (!campanhaId) {
        const campanhaIdResult = await getCampanhaPaginaVendasId();
        if (!campanhaIdResult) return;
        campanhaId = campanhaIdResult;
      }

      const pendentes = paginasVendas
        .map((p) => p.anuncio?.id ?? p.anuncio_id)
        .filter(
          (anuncioId): anuncioId is number => typeof anuncioId === "number"
        )
        .filter((anuncioId) => equipesPorAnuncio[anuncioId] === undefined);

      for (const anuncioId of pendentes) {
        await carregarEquipes(anuncioId, campanhaId);
      }
    })();
  }, [paginasVendas, empresaSelecionada?.id, campanhaPaginaVendasId]);

  async function carregarEquipes(anuncioId: number, campanhaId: number) {
    try {
      const { data } = await api.get(
        `/common/empresas/${empresaSelecionada?.id}/campanhas/${campanhaId}/anuncios/${anuncioId}/equipes`
      );
      setEquipesPorAnuncio((prev) => ({ ...prev, [anuncioId]: data.length }));
    } catch (e) {
      console.error(e);
      setEquipesPorAnuncio((prev) => ({ ...prev, [anuncioId]: 0 }));
    }
  }

  async function load() {
    try {
      const response = await api.get(
        `/common/empresas/${empresaSelecionada?.id}/sites-empresas`
      );
      setSites(await response.data);
    } catch (error) {
      console.log(error);
      notify("danger", "Não foi possível carregar os sites da empresa");
    }
  }

  async function getCampanhaPaginaVendasId(): Promise<number | null> {
    if (campanhaPaginaVendasId) return campanhaPaginaVendasId;
    if (!empresaSelecionada?.id) return null;

    try {
      // ajuste conforme sua API lista/filtra campanhas
      const { data } = await api.get(
        `/common/empresas/${empresaSelecionada.id}/campanhas`,
        {
          params: { tipo: "pagina_vendas" },
        }
      );
      // pode vir lista ou único; trate os dois
      const campanha = Array.isArray(data) ? data[0] : data;
      if (!campanha?.id) return null;

      setCampanhaPaginaVendasId(campanha.id);
      return campanha.id;
    } catch (e) {
      console.error(e);
      notify(
        "danger",
        "Não foi possível localizar a campanha de página de vendas."
      );
      return null;
    }
  }

  async function openEquipesFor(item: EmpresaModeloSite) {
    if (!empresaSelecionada?.id) {
      notify("danger", "Selecione uma empresa primeiro.");
      return;
    }

    if ((item as any).anuncio?.id && (item as any).anuncio?.campanha_id) {
      const a = (item as any).anuncio;
      setSelectedAnuncio({
        id: a.id,
        nome: a.nome,
        campanha_id: a.campanha_id,
      });
      setShowEquipesModal(true);
      return;
    }

    if (!item.anuncio_id) {
      notify("danger", "Página ainda não possui anúncio vinculado.");
      return;
    }

    const campanhaId = await getCampanhaPaginaVendasId();
    if (!campanhaId) {
      notify(
        "danger",
        "Não foi possível determinar a campanha de página de vendas."
      );
      return;
    }

    setSelectedAnuncio({
      id: item.anuncio_id,
      nome: `Anúncio #${item.anuncio_id}`,
      campanha_id: campanhaId,
    });
    setShowEquipesModal(true);
  }

  // substitua sua função atual por esta (remova duplicatas)
  async function closeEquipesModal() {
    try {
      // se houver um anúncio selecionado, recarrega a contagem de equipes dele
      if (selectedAnuncio?.id) {
        // usa o campanha_id do próprio anúncio se já tivermos
        let campanhaId: number | null = selectedAnuncio.campanha_id;
        if (!campanhaId) {
          campanhaId = await getCampanhaPaginaVendasId();
        }

        if (campanhaId) {
          await carregarEquipes(selectedAnuncio.id, campanhaId);
        }
      }
    } catch (e) {
      console.error("Falha ao recarregar equipes ao fechar modal:", e);
      // opcional: notify("danger", "Não foi possível atualizar as equipes");
    } finally {
      // fecha o modal e limpa seleção
      setShowEquipesModal(false);
      setSelectedAnuncio(null);
    }
  }

  function notify(type: string, msg: string) {
    let options = {
      place: "tc",
      message: (
        <div className="alert-text">
          <span data-notify="message">{msg}</span>
        </div>
      ),
      type: type,
      icon: "ni ni-bell-55",
      autoDismiss: 7,
    };
    if (notificationAlert) notificationAlert.current.notificationAlert(options);
  }

  function removerPaginaSelecionada(id: number) {
    setPaginaVendasSelecionadas((prev) => prev.filter((p) => p.id !== id));
  }

  async function carregarModelosSites() {
    try {
      const { data: sites } = await api.get<ModeloSite[]>(
        "/marketing/modelos-sites"
      );
      setModelosSites(sites);
    } catch (error) {
      console.error(
        "Ocorreu um erro ao tentar carregar os modelos dos sites.\n",
        error
      );
    }
  }

  function confirmarRemocaoPaginaVendas(id: string) {
    setAlert(
      <ReactBSAlert
        warning
        /* ... */
        onConfirm={async () => {
          setAlert(null);
          await removerPaginaVendas(id);
        }}
        onCancel={() => setAlert(null)}
      /* ... */
      >
        Deseja realmente remover esta página de vendas? Você poderá reativá-la
        depois.
      </ReactBSAlert>
    );
  }

  async function removerPaginaVendas(id: string) {
    if (!empresaSelecionada?.id) {
      notify("danger", "Selecione uma empresa primeiro.");
      return;
    }

    try {
      await api.patch(`/marketing/modelos-sites/empresa/${id}/status`, {
        status: false,
      });

      await carregarPaginaVendas();

      setAlert(
        <ReactBSAlert success /* ... */ onConfirm={() => setAlert(null)}>
          Página de vendas removida com sucesso.
        </ReactBSAlert>
      );
    } catch (error) {
      console.error("Erro ao remover página de vendas:", error);
      setAlert(
        <ReactBSAlert danger /* ... */ onConfirm={() => setAlert(null)}>
          Não foi possível remover a página de vendas.
        </ReactBSAlert>
      );
    }
  }

  const usadosEmpresa = new Set(paginasVendas.map((p) => p.modelo_site_id));

  const usadosNaSessao = new Set(paginaVendasSelecionadas.map((p) => p.id));

  const paginasDisponiveis = modelosSites.filter(
    (s) =>
      s.tipo_modelo === "pagina_vendas" &&
      !usadosEmpresa.has(s.id) &&
      !usadosNaSessao.has(s.id)
  );

  async function carregarPaginaVendas() {
    try {
      const { data } = await api.get<EmpresaModeloSite[]>(
        "/marketing/modelos-sites/empresa/paginas-vendas"
      );

      setPaginasVendas(asArray(data));
    } catch (error) {
      console.error(
        "Houve um erro ao carregar a(s) página(s) de vendas.",
        error
      );
    }
  }

  async function carregarPaginaIndicacao() {
    try {
      const { data: siteEmpresa } = await api.get<EmpresaModeloSite>(
        "/marketing/modelos-sites/empresa"
      );

      setPaginaIndicacao(siteEmpresa);
    } catch (error) {
      console.error("Houve um erro ao carregar os dados do site.", error);
    }
  }

  useEffect(() => {
    carregarModelosSites();
    carregarPaginaIndicacao();
    carregarPaginaVendas();
    load();
  }, [isModalVendedorVisible]);

  useEffect(() => {
    if (isModalPaginasVendasOpen) {
      carregarModelosSites();
      carregarPaginaVendas();
      setPaginaVendasSelecionadas([]);
    }
  }, [isModalPaginasVendasOpen]);

  function hideForm() {
    setShowForm(false);
  }

  function handleShowForm() {
    setShowForm(true);
  }

  return (
    <>
      {alert}

      <SelecionarModeloModal
        isOpen={isModalVendedorVisible}
        onClose={setIsModalVendedorVisible}
        pages={modelosSites.filter((site) => site.tipo_modelo == "indicacao")}
        reload={carregarPaginaIndicacao}
        currentSiteId={paginaIndicacao?.modelo_site_id}
        siteUsuario={paginaIndicacao}
      />

      <EditarModeloModal
        isOpen={isEditModalVendedorVisible}
        onClose={setIsEditModalVendedorVisible}
        reload={carregarPaginaIndicacao}
        siteEmpresa={paginaIndicacao}
      />

      <SelecionarPaginasVendasModal
        isOpen={isModalPaginasVendasOpen}
        onClose={() => setIsModalPaginasVendasOpen(false)}
        modelosSites={paginasDisponiveis} // << aqui
        paginasSelecionadas={paginaVendasSelecionadas}
        onSelecionar={(pagina) => {
          setPaginaVendasSelecionadas((prev) => [...prev, pagina]);
        }}
        reload={carregarPaginaVendas}
      />

      {selectedAnuncio && (
        <Equipes
          anuncio={selectedAnuncio}
          notify={notify}
          show={showEquipesModal}
          onClose={closeEquipesModal}
        />
      )}

      <div className="rna-wrapper">
        <NotificationAlert ref={notificationAlert} />
      </div>
      <SimpleHeader name="Sites" parentName="Minha empresa" />
      <div className="w-100">
        <Row>
          <Col>
            <Card>
              <CardHeader
                style={{
                  position: "sticky",
                  top: 0,
                  zIndex: 1,
                }}
              >
                <h1>Sites</h1>
              </CardHeader>
              <CardBody>
                <Row>
                  <Col xs={12} lg={12} md={12} sm={12}>
                    <div className="nav-wrapper">
                      <Nav
                        className="nav-fill flex-column flex-md-row"
                        pills
                        role="tablist"
                      >
                        <NavItem>
                          <NavLink
                            className={classnames("mb-sm-3 mb-md-0", {
                              active: activeTab == "indicacao",
                            })}
                            href="#"
                            onClick={() => setTabActive("indicacao")}
                            role="tab"
                          // disabled={!campanha.id}
                          >
                            Programa de indicação
                          </NavLink>
                        </NavItem>

                        <NavItem>
                          <NavLink
                            className={classnames("mb-sm-3 mb-md-0", {
                              active: activeTab == "pagina_vendas",
                            })}
                            href="#"
                            onClick={() => setTabActive("pagina_vendas")}
                            role="tab"
                          // disabled={!campanha.id}
                          >
                            Página de vendas
                          </NavLink>
                        </NavItem>

                        <NavItem>
                          <NavLink
                            href="#"
                            role="tab"
                            className={classnames("mb-sm-3 mb-md-0", {
                              active: activeTab == "site",
                            })}
                            onClick={() => setTabActive("site")}
                          >
                            Sites
                          </NavLink>
                        </NavItem>
                      </Nav>
                    </div>
                    <hr />
                    <div>
                      <TabContent activeTab={activeTab}>
                        <TabPane tabId="site">
                          {empresaSelecionada && (
                            <Form
                              empresa={empresaSelecionada}
                              hide={hideForm}
                              notify={notify}
                              success={load}
                              show={showForm}
                              site={{} as SiteEmpresa}
                            />
                          )}
                          <div
                            style={{
                              display: "flex",
                              flex: 1,
                              justifyContent: "center",
                            }}
                          >
                            <Button
                              color="primary"
                              type="button"
                              className="btn-icon btn-3"
                              onClick={handleShowForm}
                            >
                              <span className="btn-inner--icon">
                                <i className="ni ni-fat-add"></i>
                              </span>
                              <span className="btn-inner--text">Novo Site</span>
                            </Button>
                          </div>

                          {empresaSelecionada && (
                            <List
                              sites={sites}
                              empresa={empresaSelecionada}
                              notify={notify}
                              reLoad={load}
                            />
                          )}
                        </TabPane>

                        <TabPane tabId="pagina_vendas">
                          <Button
                            color="primary"
                            onClick={() => setIsModalPaginasVendasOpen(true)}
                            className="mb-3"
                          >
                            + Adicionar Página de Vendas
                          </Button>

                          <Row>
                            {paginasVendas.length === 0 && (
                              <Col>
                                <p>
                                  Nenhuma página de vendas cadastrada ainda.
                                </p>
                              </Col>
                            )}

                            {paginasVendas.map((item, index) => {
                              const anuncioId =
                                item.anuncio?.id ?? item.anuncio_id;
                              const equipesCount = anuncioId
                                ? equipesPorAnuncio[anuncioId] ?? 0
                                : 0;
                              const copiarLinkDisabled =
                                !anuncioId || equipesCount === 0;

                              return (
                                <Col xs={12} sm={6} md={4} key={item.id}>
                                  <Card>
                                    <CardImg
                                      top
                                      src={`${item.site.link}preview.png`}
                                      alt={`Página de vendas ${index + 1}`}
                                    />
                                    <CardBody>
                                      <CardTitle>{`Página de vendas ${index + 1
                                        }`}</CardTitle>

                                      <div
                                        style={{
                                          display: "flex",
                                          gap: 8,
                                          flexWrap: "wrap",
                                        }}
                                      >
                                        <Button
                                          color="info"
                                          size="sm"
                                          disabled={loadingAnuncio}
                                          onClick={() => openEquipesFor(item)}
                                        >
                                          {loadingAnuncio
                                            ? "Abrindo..."
                                            : "Adicionar Equipes"}
                                        </Button>

                                        <Button
                                          color="primary"
                                          size="sm"
                                          title={
                                            copiarLinkDisabled
                                              ? "Adicione equipes para copiar o link"
                                              : undefined
                                          }
                                          onClick={() => {
                                            const linkBase =
                                              item.short_url ?? item.site.link;
                                            const linkFinal = `${linkBase}?EMS=${item.id}`;
                                            navigator.clipboard.writeText(
                                              linkFinal
                                            );
                                            notify("success", "Link copiado!");
                                          }}
                                        >
                                          Copiar Link
                                        </Button>

                                        <Button
                                          color="danger"
                                          size="sm"
                                          onClick={() =>
                                            removerPaginaVendas(item.id)
                                          }
                                        >
                                          Remover
                                        </Button>
                                      </div>
                                    </CardBody>
                                  </Card>
                                </Col>
                              );
                            })}
                          </Row>
                        </TabPane>

                        <TabPane tabId="indicacao">
                          <Row>
                            <Col xs={12} sm={6}>
                              <Card>
                                <CardImg
                                  src={`${paginaIndicacao?.site.link}preview.png`}
                                />
                                <CardBody>
                                  <CardTitle tag="h3">
                                    Programa de Indicação
                                  </CardTitle>
                                  <CardText>
                                    <Button
                                      color="primary"
                                      size="sm"
                                      onClick={setIsModalVendedorVisible}
                                    >
                                      Selecionar Modelo
                                    </Button>
                                    <Button
                                      color="primary"
                                      size="sm"
                                      onClick={setIsEditModalVendedorVisible}
                                      disabled={!paginaIndicacao?.id}
                                    >
                                      Editar Modelo
                                    </Button>
                                  </CardText>
                                </CardBody>
                              </Card>
                            </Col>
                          </Row>
                        </TabPane>
                      </TabContent>
                    </div>
                  </Col>
                </Row>
              </CardBody>
            </Card>
          </Col>
        </Row>
      </div>
    </>
  );
};

export default Sites;
